import { useState, useEffect } from 'react'
import { FiSave, FiLock, FiAward } from 'react-icons/fi'

import api from '../../utils/api'
import useFlashMessage from '../../hooks/useFlashMessage'
import Input from '../../shared/components/form/Input'
import PasswordChecklist from '../../shared/components/form/PasswordChecklist'

import './Perfil.css'

function Perfil() {
    const [user, setUser] = useState(null)
    const [savingProfile, setSavingProfile] = useState(false)
    const [passwordForm, setPasswordForm] = useState({})
    const [savingPassword, setSavingPassword] = useState(false)
    const { setFlashMessage } = useFlashMessage()

    useEffect(() => {
        api.get('/user/perfil/me').then((response) => {
            setUser(response.data.user)
        }).catch((error) => {
            setFlashMessage(error.response?.data?.message || 'Não foi possível carregar o perfil', 'error')
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function handleChange(e) {
        setUser({ ...user, [e.target.name]: e.target.value })
    }

    function handlePasswordChange(e) {
        setPasswordForm({ ...passwordForm, [e.target.name]: e.target.value })
    }

    async function handleProfileSubmit(e) {
        e.preventDefault()
        setSavingProfile(true)
        try {
            const { data } = await api.patch('/user/perfil', { name: user.name, email: user.email, phone: user.phone })
            setFlashMessage(data.message, 'success')
        } catch (error) {
            setFlashMessage(error.response?.data?.message || 'Não foi possível salvar o perfil', 'error')
        }
        setSavingProfile(false)
    }

    async function handlePasswordSubmit(e) {
        e.preventDefault()
        setSavingPassword(true)
        try {
            const { data } = await api.patch('/user/changepwd', passwordForm)
            setFlashMessage(data.message, 'success')
            setPasswordForm({})
        } catch (error) {
            setFlashMessage(error.response?.data?.message || 'Não foi possível trocar a senha', 'error')
        }
        setSavingPassword(false)
    }

    if (!user) {
        return <div className="perfil-loading">Carregando perfil...</div>
    }

    return (
        <div className="perfil">
            <section className="perfil-header panel">
                <div>
                    <p className="perfil-eyebrow">Jogador</p>
                    <h1>{user.name}</h1>
                    <p className="perfil-username">@{user.userName}</p>
                </div>
                <div className="perfil-points">
                    <FiAward size={22} />
                    <span>{user.points ?? 0}</span>
                    <p>pontos</p>
                </div>
            </section>

            <section className="perfil-stats panel">
                <div className="perfil-stat">
                    <span className="perfil-stat-value">{user.totalKills ?? 0}</span>
                    <p className="perfil-stat-label">kills</p>
                </div>
                <div className="perfil-stat">
                    <span className="perfil-stat-value">{user.totalDeaths ?? 0}</span>
                    <p className="perfil-stat-label">mortes</p>
                </div>
                <div className="perfil-stat">
                    <span className="perfil-stat-value">{user.totalVitorias ?? 0}</span>
                    <p className="perfil-stat-label">vitórias</p>
                </div>
                <div className="perfil-stat">
                    <span className="perfil-stat-value">{user.totalDerrotas ?? 0}</span>
                    <p className="perfil-stat-label">derrotas</p>
                </div>
            </section>

            <div className="perfil-grid">
                <form onSubmit={handleProfileSubmit} className="perfil-card panel">
                    <h2>Dados do perfil</h2>
                    <Input
                        text="Nome"
                        type="text"
                        name="name"
                        handleOnChange={handleChange}
                        value={user.name || ''}
                    />
                    <Input
                        text="Email"
                        type="email"
                        name="email"
                        handleOnChange={handleChange}
                        value={user.email || ''}
                    />
                    <Input
                        text="Telefone"
                        type="tel"
                        name="phone"
                        handleOnChange={handleChange}
                        value={user.phone || ''}
                    />
                    <button className="btn-primary perfil-submit" type="submit" disabled={savingProfile}>
                        <FiSave size={16} />
                        {savingProfile ? 'Salvando...' : 'Salvar alterações'}
                    </button>
                </form>

                <form onSubmit={handlePasswordSubmit} className="perfil-card panel">
                    <h2>Trocar senha</h2>
                    <Input
                        text="Nova senha"
                        type="password"
                        name="password"
                        handleOnChange={handlePasswordChange}
                        value={passwordForm.password || ''}
                    />
                    <PasswordChecklist password={passwordForm.password} />
                    <Input
                        text="Confirmar nova senha"
                        type="password"
                        name="confirmPassword"
                        placeholder="Repita a nova senha"
                        handleOnChange={handlePasswordChange}
                        value={passwordForm.confirmPassword || ''}
                    />
                    <button className="btn-primary perfil-submit" type="submit" disabled={savingPassword}>
                        <FiLock size={16} />
                        {savingPassword ? 'Salvando...' : 'Atualizar senha'}
                    </button>
                </form>
            </div>
        </div>
    )
}

export default Perfil
